<template>
   <v-card>
       <v-card-title>Контакты</v-card-title>
       <v-card-text>
           <v-row>
               <v-col>
                   <v-btn  color="primary" @click="onClickCreate">
                       Создать
                   </v-btn>
               </v-col>
           </v-row>
           <v-row>
               <v-col>
                   <contacts-table :init-jur-id="jurId"/>
               </v-col>
           </v-row>
       </v-card-text>
   </v-card>
</template>

<script>

import ContactsTable from "../../components/contragents/ContactTable.vue";

export default {
    name: "ContactsPage",
    components: {ContactsTable},
    mounted() {
    },
    data(){
        return {

        }
    },
    watch: {},
    methods: {
        onClickCreate(){
            if(this.jurId){
                this.$router.push({name: 'JurContactCreatePage', params:{jurId: this.jurId}})
            }else {
                this.$router.push({name: 'ContactCreatePage'})
            }
        }
    },
    computed: {
        jurId(){
            return this.$route.params.jurId;
        }
    }
}
</script>

<style scoped>

</style>